import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getProcedureUIString, {ProceduresStringKeys, StringCase} from 'procedures/ProceduresStringKeys';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

interface NoParametersWarningBannerProps {
  procedureType: ProcedureType;
  conditionsText: string;
}

export default function NoParametersWarningBanner(props: NoParametersWarningBannerProps): JSX.Element {
  const methodUIString = getProcedureUIString(ProceduresStringKeys.METHOD, props.procedureType, {
    stringCase: StringCase.LOWER,
  });
  const procedureUIString = getProcedureUIString(ProceduresStringKeys.PROCEDURE, props.procedureType, {
    stringCase: StringCase.LOWER,
  });
  return (
    <InlineBanner
      bannerType={InlineBannerType.WARNING}
      text={`Parameters, material inputs, and equipment were not added to this ${methodUIString}.`}
      supportingInfo={`To vary ${props.conditionsText} for this ${methodUIString}, close the experiment plan and edit this ${methodUIString} in the ${procedureUIString}.`}
    />
  );
}
